import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import usePrevious from 'src/common/hooks/usePrevious';
import { useStores } from 'src/common/providers';
import { selectIsAuthenticated } from 'src/common/selectors/auth';

export function useAuthEffects() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const prevIsAuthenticated = usePrevious(isAuthenticated);
  const { favoritesStore } = useStores();
  const favoriteOnAuthCallback = favoritesStore.favoriteOnAuthCallback();

  useEffect(() => {
    if (isAuthenticated && !prevIsAuthenticated) {
      favoriteOnAuthCallback?.();
    }
  }, [isAuthenticated, prevIsAuthenticated, favoriteOnAuthCallback]);
}
